import lazyLoad from '@utils/lazyLoad'
import { setApplicationCode } from '@utils/utils'
import applicationCode from '@enum/applicationCode'

const ChannelManagementRoutes = [
  // 会员注册协议列表
  {
    path: '/channel_management/brand_list',
    exact: true,
    component: lazyLoad(() => import('@views/ChannelManagement/BrandList')),
    meta: {
      layoutMode: 'empty'
    }
  },
  {
    path: '/channel_management/brand/:id',
    exact: true,
    component: lazyLoad(() => import('@views/ChannelManagement/BrandDetail')),
    meta: {
      layoutMode: 'empty',
      title: '品牌详情'
    }
  },
  {
    path: '/channel_management/channel_list',
    exact: true,
    component: lazyLoad(() => import('@views/ChannelManagement/ChannelList')),
    meta: {
      layoutMode: 'empty'
    }
  },
  {
    path: '/channel_management/channel/:id',
    exact: true,
    component: lazyLoad(() => import('@views/ChannelManagement/ChannelDetail')),
    meta: {
      layoutMode: 'empty',
      title: '渠道详情'
    }
  },
  {
    path: '/channel_management/channel_group_list',
    exact: true,
    component: lazyLoad(() =>
      import('@views/ChannelManagement/ChannelGroupList')
    ),
    meta: {
      layoutMode: 'empty'
    }
  },
  {
    path: '/channel_management/channel_group/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/ChannelManagement/ChannelGroupDetail')
    ),
    meta: {
      layoutMode: 'empty',
      title: '渠道组详情'
    }
  }
]

export default setApplicationCode(applicationCode.settings)(
  ChannelManagementRoutes
)
